import { ChannelItemContentPopup } from "../channelList/ChannelDetailsPopup";
import { ChannelsListPopup, MerchantChannelEditor, PaymentChannelEditor } from "../channelList/Channels";
import { AddFeesPopup } from "../Fees";
import { IntegrationEditorPopup } from "../pages/IntegrationsList";
import { AddFeesDialog } from "./ModernFees";
import { PaymentProviderEditor, ProviderDetailsPopup } from "./ProvidersList";

export const ProvidersPopupContainer = () => {
	return (
		<>
			<ProviderDetailsPopup />
			<ChannelItemContentPopup />
			<ChannelsListPopup />
			<PaymentProviderEditor />
			<PaymentChannelEditor />
			<IntegrationEditorPopup />
			<AddFeesPopup />
			<AddFeesDialog />
			<MerchantChannelEditor />
		</>
	);
};
